import { render, staticRenderFns } from "./MerchantOverview.vue?vue&type=template&id=d33f2996&scoped=true"
import script from "./MerchantOverview.vue?vue&type=script&lang=js"
export * from "./MerchantOverview.vue?vue&type=script&lang=js"
import style0 from "./MerchantOverview.vue?vue&type=style&index=0&id=d33f2996&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33f2996",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d33f2996')) {
      api.createRecord('d33f2996', component.options)
    } else {
      api.reload('d33f2996', component.options)
    }
    module.hot.accept("./MerchantOverview.vue?vue&type=template&id=d33f2996&scoped=true", function () {
      api.rerender('d33f2996', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/MerchantOverview.vue"
export default component.exports